import React, { useState } from "react";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import { api_key_paypal } from "../../utils/helper";

const Index = () => {
  // Tomar valor que el usuario ingrese por precio de su curso.
  // eslint-disable-next-line no-unused-vars
  const [price, setPrice] = useState("99.99");
  const [orderID, setOrderID] = useState(null);
  const [paid, setPaid] = useState(false);

  // Esta función se llama cuando el pago se aprueba correctamente
  const handleApprove = (data, actions) => {
    // Captura el pago utilizando actions.order.capture() y maneja los detalles de la respuesta utilizando la función then()
    return actions.order.capture().then(function (details) {
      // Establece el estado de "paid" en "true" para indicar que el pago ha sido realizado con éxito
      setPaid(true);
      // Mostrar los detalles del pago en la consola
      // console.log(details);
    });
  };

  return (
    <div className="flex justify-center items-center h-screen">
      <div className="max-w-sm rounded overflow-hidden shadow-lg">
        <img
          className="w-full"
          src="https://source.unsplash.com/random/400x200"
          alt="Producto"
        />
        <div className="px-6 py-4">
          <div className="font-bold text-xl mb-2">Nombre del Producto</div>
          <p className="text-gray-700 text-base">
            Descripción corta del producto.
          </p>
          <p className="text-gray-700 text-base">${price}</p>
        </div>
        <div className="px-6 pt-4 pb-2">
          <PayPalScriptProvider
            options={{
              "client-id": { api_key_paypal },
            }}
          >
            <PayPalButtons
              createOrder={(data, actions) => {
                return actions.order
                  .create({
                    purchase_units: [
                      {
                        amount: {
                          value: price,
                        },
                      },
                    ],
                  })
                  .then(function (orderID) {
                    setOrderID(orderID);
                    return orderID;
                  });
              }}
              onApprove={handleApprove}
            />
          </PayPalScriptProvider>
        </div>
        {paid && (
          <div className="px-6 py-4">
            <p className="text-gray-700 text-base">Pago realizado con éxito!</p>
            <p className="text-gray-700 text-base">ID de orden: {orderID}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Index;
